import type { AccessProvider } from '../schemas/projectAccess.ts'

export interface AccessGuidance { title: string; instructions: string; docs: string | null; input: 'retry' }

// Provider instructions are shared by deterministic chat notices and the inline recovery card.
export function accessGuidance(provider: AccessProvider): AccessGuidance {
  switch (provider) {
    case 'cloudflare': return {
      title: 'Cloudflare bot protection', input: 'retry',
      instructions: 'Follow the screenshot guide to turn off Bot Fight Mode or allow automated traffic in Super Bot Fight Mode for your QA environment, then retry.',
      docs: 'https://docs.replay.io/basics/replay-qa/cloudflare',
    }
    case 'turnstile': return {
      title: 'Cloudflare Turnstile challenge', input: 'retry',
      instructions: 'In your preview or test environment, replace both the Turnstile client sitekey and server validation secret with Cloudflare’s always-pass test keys from the linked guide, then redeploy. Changing only the sitekey will still fail server validation. Alternatively disable the widget and its server-side requirement for that test environment.',
      docs: 'https://docs.replay.io/basics/replay-qa/cloudflare',
    }
  }
}
